export const COMPENSATION_CYCLES_STATUS_VALUES = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
};

export const COMPENSATION_CYCLES_STATUS_LABELS = {
  [COMPENSATION_CYCLES_STATUS_VALUES.DRAFT]: 'Draft',
  [COMPENSATION_CYCLES_STATUS_VALUES.ACTIVE]: 'Active',
  [COMPENSATION_CYCLES_STATUS_VALUES.COMPLETED]: 'Completed',
};

export const COMPENSATION_CYCLES_STATUS_COLORS = {
  [COMPENSATION_CYCLES_STATUS_VALUES.DRAFT]: 'darkYellow',
  [COMPENSATION_CYCLES_STATUS_VALUES.ACTIVE]: 'green',
  [COMPENSATION_CYCLES_STATUS_VALUES.COMPLETED]: 'darkGreen',
};

export type CompensationCycleData = {
  id: number;
  cycleName: string;
  preset: string;
  status: keyof typeof COMPENSATION_CYCLES_STATUS_VALUES;
  launchDate: string;
};
